<template>
  <div class="col-xxl-3 col-xl-12 col-lg-12 col-12">
    <div class="card p-3">
      <div class="card-body">
        <div class="mb-4 text-start">
          <div class="total-title">Total commission</div>
          <div class="comission-value">{{ formatCurrency(totalCommission) }}</div>
        </div>
        <div class="text-start mb-custom">
          <div class="total-title">Total face value</div>
          <div class="face-value">{{ formatCurrency(totalFaceValue) }}</div>
        </div>
        <hr />
        <div class="mb-3 text-start">
          <div class="subtitle">Transactions</div>
          <div class="sub-value">{{ transactionCount }}</div>
        </div>
        <div class="mb-3 text-start">
          <div class="subtitle">Total fees paid</div>
          <div class="sub-value">{{ formatCurrency(totalFeesPaid) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useReportStore } from '@/store/driver/report';

const { reportInfo, fetchReportInfo } = useReportStore();

const totalFaceValue = computed(() => reportInfo.total_face_value || 0);
const totalCommission = computed(() => reportInfo.total_commission || 0);
const transactionCount = computed(() => reportInfo.transaction_count || 0);
const totalFeesPaid = computed(() => reportInfo.total_fees_paid || 0);

const formatCurrency = (value) => {
  const absValue = Math.abs(value); // 取得絕對值並固定為兩位小數
  return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

</script>

<style scoped>
.card{
 min-height: 627px;
}

.card-body {
  margin-bottom: 22px;
}

.total-title{
  font-family: Mulish;
  font-size: 18px;
  font-weight: 400;
  line-height: 22.59px;
  text-align: left;
}

.comission-value{
  font-family: Euclid Square;
  font-size: 42px;
  font-weight: 600;
  line-height: 53.26px;
  text-align: left;
}

.face-value{
  font-family: Euclid Square;
  font-size: 42px;
  font-weight: 400;
  line-height: 53.26px;
  text-align: left;
}

.subtitle{
  font-family: Mulish;
  font-size: 15px;
  font-weight: 400;
  line-height: 18.83px;
  text-align: left;
}

.sub-value{
  font-family: Euclid Square;
  font-size: 24px;
  font-weight: 500;
  line-height: 30.43px;
  text-align: left;
  margin-top: 5px;
}

h6 {
  color: #6c757d;
}

h3 {
  font-size: 28px;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  margin-bottom: 0;
}

.mb-custom {
  margin-bottom: 170px;
}

hr {
  margin: 20px 0;
  border-top: 2px solid gray;
}

@media (max-width:1651px) {
  .card-body {
    margin-bottom: 0px;
  }
}

@media (max-width:1460px) {
  h3 {
    font-size: 20px;
  }

  h2 {
    font-size: 24px;
  }
}
</style>
